/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */
/* ============================================================
 * PRE-SALE / CH LIEFERZEIT-OVERRIDE – Birthday Weeks 2026
 * Entscheidet clientseitig (wegen CDN-Caching pro Markt), welcher
 * "auf Lager"-Text angezeigt wird. Einzige Quelle der Wahrheit für
 * die SKU-Liste ist presale_skus in snippets/product-form.liquid.
 * ============================================================ */
(function () {
  function getPresaleMap(wrapper) {
    var script = wrapper.querySelector('script[data-variant-presale-map]');
    if (!script) return {};
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return {};
    }
  }

  function updateInventoryMessage(wrapper, isPresale) {
    if (!wrapper) return;

    var badge = wrapper.querySelector('.inventory--high');
    if (!badge) return; // low stock / oversell / incoming bleiben unberührt

    var isCH = window.Shopify && window.Shopify.country && window.Shopify.country !== 'DE'; // CW2026: 5-7-Werktage-Text fuer alle Laender ausser DE (vorher: === 'CH')
    var text;

    if (isPresale) {
      text = isCH ? wrapper.dataset.presaleCh : wrapper.dataset.presaleDefault;
    } else if (isCH) {
      text = wrapper.dataset.instockCh;
    } else {
      text = wrapper.dataset.instockDefault;
    }

    if (text) badge.textContent = text;
  }

  function refresh(form) {
    if (!form) return;
    var formId = form.getAttribute('id');
    if (!formId) return;

    var idInput = form.querySelector('input[name="id"]');
    var wrapper = document.querySelector('product-inventory[form-id="' + formId + '"]');
    if (!idInput || !wrapper) return;

    var presaleMap = getPresaleMap(wrapper);
    updateInventoryMessage(wrapper, !!presaleMap[idInput.value]);
  }

  function refreshAll() {
    document.querySelectorAll('form[id^="product-form-"]').forEach(refresh);
  }

  refreshAll();
  document.addEventListener('DOMContentLoaded', refreshAll);
  window.addEventListener('load', refreshAll);

  document.addEventListener('variant:changed', function (event) {
    refresh(event.target);
  });
})();

/**
 * POP-902 | Mobile PDP gallery arrows.
 *
 * Only show the arrows that actually lead somewhere: right arrow on the first image,
 * both in between, left arrow on the last. The buttons ship with the `hidden` attribute
 * so nothing flashes before this runs.
 *
 * Cell count is read from Flickity rather than product.media, so variant-filtered images
 * are accounted for automatically (a variant change destroys and rebuilds the carousel,
 * which fires flickity:ready again).
 */
(function () {
  function updateArrows(carousel) {
    if (!carousel || !carousel.flickityInstance) return;

    var nav = carousel.parentElement.querySelector('.product__media-overlay-nav');
    if (!nav) return;

    var prev = nav.querySelector('[data-action="prev"]');
    var next = nav.querySelector('[data-action="next"]');

    carousel.flickityInstance.then(function (flickity) {
      var count = flickity.cells.length;
      var index = flickity.selectedIndex;

      if (prev) prev.hidden = count < 2 || index <= 0;
      if (next) next.hidden = count < 2 || index >= count - 1;
    });
  }

  function onCarouselEvent(event) {
    var carousel = event.target;
    if (!carousel.classList || !carousel.classList.contains('product__media-list')) return;
    updateArrows(carousel);
  }

  document.addEventListener('flickity:ready', onCarouselEvent);
  document.addEventListener('flickity:slide-changed', onCarouselEvent);

  // Safety net in case a carousel was already initialised before this listener attached.
  function refreshAll() {
    document.querySelectorAll('.product__media-list').forEach(updateArrows);
  }

  refreshAll();
  document.addEventListener('DOMContentLoaded', refreshAll);
  window.addEventListener('load', refreshAll);
})();
